import React from 'react'
import GoogleMapReact from 'google-map-react'
import { GOOGLE_MAPS_API_KEY } from 'gatsby-env-variables'
import SmallLogo from '../atoms/SmallLogo'
import { createUseStyles } from 'react-jss'
import PropTypes from 'prop-types'

const GoogleMap = ({ children, mapCenter, zoom, customStyles, }) => {
  const classes = useStyles({ customStyles, })

  return (
  <div className={classes.googleMap}>
    <GoogleMapReact
      bootstrapURLKeys={{ key: GOOGLE_MAPS_API_KEY, }}
      defaultCenter={mapCenter}
      defaultZoom={zoom}
    >
      <SmallLogo
        lat={49.885009}
        lng={20.085285}
      />
      {children}
    </GoogleMapReact>
  </div>
  )
}

GoogleMap.propTypes = {
  children: PropTypes.func,
  mapCenter: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  customStyles: PropTypes.object,
}

const useStyles = createUseStyles({
  googleMap: props => ({
    height: '60vh',
    width: '97%',
    margin: 'auto',
    marginTop: '2em',
    marginBottom: '2em',
    ...props.customStyles,
  }),
  '@media (max-width: 960px)': {
    googleMap: {
      width: '95% !important',
    },
  },
})

export default GoogleMap
